// extracted by mini-css-extract-plugin
module.exports = {"container":"container--1suUS","message":"message--3HRcG"};